import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import EnhancedLoadingSpinner from './EnhancedLoadingSpinner';

interface ClientProtectedRouteProps {
  children: React.ReactNode;
}

const ClientProtectedRoute: React.FC<ClientProtectedRouteProps> = ({ children }) => {
  const { isClient, loading } = useAuth();

  if (loading) {
    return <EnhancedLoadingSpinner fullScreen text="Loading..." />;
  }

  if (!isClient) {
    return <Navigate to="/client/login" replace />;
  }

  return <>{children}</>;
};

export default ClientProtectedRoute;
